import { httpClient } from '@/shared/api/httpClient';
import type { EtapaKanban } from '@/features/orcamentos/api/etapasKanban';

/** Quantas OS existem hoje em cada etapa — usado na tela de configuração. */
export type ContagemEtapas = Record<string, number>;

export type EtapasKanbanResposta = {
  etapas: EtapaKanban[];
  contagem: ContagemEtapas;
  /**
   * true quando a conta nunca personalizou as etapas e está vendo o
   * conjunto de fábrica.
   */
  padrao: boolean;
};

/** Para onde vão as OS de uma etapa que está sendo apagada. */
export type RemanejamentoEtapa = { de: string; para: string };

export type SalvarEtapasRequest = {
  etapas: EtapaKanban[];
  remanejar?: RemanejamentoEtapa[];
};

export const kanbanApi = {
  obterEtapas: () => httpClient.get<EtapasKanbanResposta>('/api/kanban/etapas'),
  salvarEtapas: (cmd: SalvarEtapasRequest) =>
    httpClient.put<EtapasKanbanResposta>('/api/kanban/etapas', cmd),
  restaurarPadrao: () =>
    httpClient.post<EtapasKanbanResposta>('/api/kanban/etapas/restaurar', {}),
};
